/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getLabTestItems } from 'app/entities/lab-test-item/lab-test-item.reducer';
import { getEntities as getDiagLabs } from 'app/entities/diag-lab/diag-lab.reducer';
import { Gender } from 'app/shared/model/enumerations/gender.model';
import { createEntity, getEntity, reset, updateEntity } from './lab-test-item-limit.reducer';

export const LabTestItemLimitUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const labTestItems = useAppSelector(state => state.labTestItem.entities);
  const diagLabs = useAppSelector(state => state.diagLab.entities);
  const labTestItemLimitEntity = useAppSelector(state => state.labTestItemLimit.entity);
  const loading = useAppSelector(state => state.labTestItemLimit.loading);
  const updating = useAppSelector(state => state.labTestItemLimit.updating);
  const updateSuccess = useAppSelector(state => state.labTestItemLimit.updateSuccess);
  const genderValues = Object.keys(Gender);

  const handleClose = () => {
    navigate(`/lab-test-item-limit${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getLabTestItems({}));
    dispatch(getDiagLabs({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.ageMin !== undefined && typeof values.ageMin !== 'number') {
      values.ageMin = Number(values.ageMin);
    }
    if (values.ageMax !== undefined && typeof values.ageMax !== 'number') {
      values.ageMax = Number(values.ageMax);
    }
    if (values.weightMin !== undefined && typeof values.weightMin !== 'number') {
      values.weightMin = Number(values.weightMin);
    }
    if (values.weightMax !== undefined && typeof values.weightMax !== 'number') {
      values.weightMax = Number(values.weightMax);
    }
    if (values.bsaMin !== undefined && typeof values.bsaMin !== 'number') {
      values.bsaMin = Number(values.bsaMin);
    }
    if (values.bsaMax !== undefined && typeof values.bsaMax !== 'number') {
      values.bsaMax = Number(values.bsaMax);
    }

    const entity = {
      ...labTestItemLimitEntity,
      ...values,
      testItem: labTestItems.find(it => it.id.toString() === values.testItem?.toString()),
      lab: diagLabs.find(it => it.id.toString() === values.lab?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          gender: 'NA',
          ...labTestItemLimitEntity,
          testItem: labTestItemLimitEntity?.testItem?.id,
          lab: labTestItemLimitEntity?.lab?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.labTestItemLimit.home.createOrEditLabel" data-cy="LabTestItemLimitCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.labTestItemLimit.home.createOrEditLabel">Create or edit a LabTestItemLimit</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="lab-test-item-limit-id"
                  label={translate('tinyMedicRestApp.labTestItemLimit.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.active')}
                id="lab-test-item-limit-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.lastUpdated')}
                id="lab-test-item-limit-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.timestampEntry')}
                id="lab-test-item-limit-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.microSec')}
                id="lab-test-item-limit-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.cursor')}
                id="lab-test-item-limit-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.unitsOfMeasure')}
                id="lab-test-item-limit-unitsOfMeasure"
                name="unitsOfMeasure"
                data-cy="unitsOfMeasure"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.resultType')}
                id="lab-test-item-limit-resultType"
                name="resultType"
                data-cy="resultType"
                type="text"
                validate={{
                  maxLength: { value: 200, message: translate('entity.validation.maxlength', { max: 200 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.normalRangeLowerLimit')}
                id="lab-test-item-limit-normalRangeLowerLimit"
                name="normalRangeLowerLimit"
                data-cy="normalRangeLowerLimit"
                type="text"
                validate={{
                  maxLength: { value: 200, message: translate('entity.validation.maxlength', { max: 200 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.normalRangeUpperLimit')}
                id="lab-test-item-limit-normalRangeUpperLimit"
                name="normalRangeUpperLimit"
                data-cy="normalRangeUpperLimit"
                type="text"
                validate={{
                  maxLength: { value: 100, message: translate('entity.validation.maxlength', { max: 100 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.possibleRangeLowerLimit')}
                id="lab-test-item-limit-possibleRangeLowerLimit"
                name="possibleRangeLowerLimit"
                data-cy="possibleRangeLowerLimit"
                type="text"
                validate={{
                  maxLength: { value: 200, message: translate('entity.validation.maxlength', { max: 200 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.possibleRangeUpperLimit')}
                id="lab-test-item-limit-possibleRangeUpperLimit"
                name="possibleRangeUpperLimit"
                data-cy="possibleRangeUpperLimit"
                type="text"
                validate={{
                  maxLength: { value: 200, message: translate('entity.validation.maxlength', { max: 200 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.template')}
                id="lab-test-item-limit-template"
                name="template"
                data-cy="template"
                type="text"
                validate={{
                  maxLength: { value: 5000, message: translate('entity.validation.maxlength', { max: 5000 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.ageMin')}
                id="lab-test-item-limit-ageMin"
                name="ageMin"
                data-cy="ageMin"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.ageMax')}
                id="lab-test-item-limit-ageMax"
                name="ageMax"
                data-cy="ageMax"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.gender')}
                id="lab-test-item-limit-gender"
                name="gender"
                data-cy="gender"
                type="select"
              >
                {genderValues.map(gender => (
                  <option value={gender} key={gender}>
                    {translate(`tinyMedicRestApp.Gender.${gender}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.weightMin')}
                id="lab-test-item-limit-weightMin"
                name="weightMin"
                data-cy="weightMin"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.weightMax')}
                id="lab-test-item-limit-weightMax"
                name="weightMax"
                data-cy="weightMax"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.bsaMin')}
                id="lab-test-item-limit-bsaMin"
                name="bsaMin"
                data-cy="bsaMin"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.bsaMax')}
                id="lab-test-item-limit-bsaMax"
                name="bsaMax"
                data-cy="bsaMax"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestItemLimit.displayPrecision')}
                id="lab-test-item-limit-displayPrecision"
                name="displayPrecision"
                data-cy="displayPrecision"
                check
                type="checkbox"
              />
              <ValidatedField
                id="lab-test-item-limit-testItem"
                name="testItem"
                data-cy="testItem"
                label={translate('tinyMedicRestApp.labTestItemLimit.testItem')}
                type="select"
                required
              >
                <option value="" key="0" />
                {labTestItems
                  ? labTestItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="lab-test-item-limit-lab"
                name="lab"
                data-cy="lab"
                label={translate('tinyMedicRestApp.labTestItemLimit.lab')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabs
                  ? diagLabs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/lab-test-item-limit" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default LabTestItemLimitUpdate;
